import { render, staticRenderFns } from "./Sports.vue?vue&type=template&id=c27a899e&scoped=true&"
import script from "./Sports.vue?vue&type=script&lang=js&"
export * from "./Sports.vue?vue&type=script&lang=js&"
import style0 from "./Sports.vue?vue&type=style&index=0&id=c27a899e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27a899e",
  null
  
)

export default component.exports